import React from 'react';

export default ({id, className = '', helperText, showError, error}) => (
  helperText || (showError && error)
    ? (
        <div className={['helper-text', className].join(' ')}>
          {showError
            ? (
              <span
                id={id ? `${id}Error` : ''}
                className="helper-text__error"
              >
                {error || 'Invalid value'}
              </span>
            ) : !!helperText
              ? (
                <span className="helper-text__hint">
                  {helperText}
                </span>
              ) : null
          }
        </div>
      ) : null
);
